import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
  Card,
  CardContent,
  Select,
  MenuItem,
  CardActions,
  Box,
  Breadcrumbs,
  FormControl,
  InputLabel,
  TextField,
  FormHelperText,
  Button,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import userManualService from "../../../services/userManual";
import { instanceToken } from "../../../utils/constant";

export default function CreateUserManual({ homeAlert }) {
  const navigate = useNavigate();
  const [question, setQuestion] = useState("");
  const [questionMM, setQuestionMM] = useState("");
  const [answers, setAnswers] = useState([{ answer_en: "", answer_mm: "" }]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleAddAnswer = () => {
    setAnswers([...answers, { answer_en: "", answer_mm: "" }]);
  };

  const handleAnswerChange = (index, field, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index][field] = value;
    setAnswers(updatedAnswers);
  };

  const handleRemoveAnswer = (index) => {
    const updatedAnswers = [...answers];
    updatedAnswers.splice(index, 1);
    setAnswers(updatedAnswers);
  };

  const handleCreate = async () => {
    const err = {};

    if (!question.trim()) err.question = "Question in English is required.";
    if (!questionMM.trim()) err.questionMM = "Question in Myanmar is required.";

    if (
      answers.some(
        (answer) => !answer.answer_en.trim() || !answer.answer_mm.trim()
      )
    ) {
      err.answers = "Both English and Myanmar answers are required.";
    }

    if (Object.keys(err).length > 0) {
      setErrors(err);
      return;
    }

    try {
      setLoading(true);
      const data = {
        question_mm: questionMM,
        question_en: question,
        answers: answers,
      };
      console.log(data);

      // Example API call
      await userManualService.createUserManual(instanceToken.token, data);
      homeAlert("User Manual has been created.", false);
      navigate("/user-manual");
    } catch (error) {
      homeAlert("Failed to create User Manual!", true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div role="presentation" style={{ marginBottom: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/faqs">User Manual</Link>
          <span>Create User Manual</span>
        </Breadcrumbs>
      </div>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card sx={{ minWidth: "80vw" }}>
          <CardContent sx={{ display: "flex", flexDirection: "column" }}>
            {/* Questions */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              <FormControl sx={{ my: 2 }}>
                <TextField
                  label="Title (English)"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  error={!!errors.question}
                  helperText={errors.question}
                />
              </FormControl>
              <FormControl sx={{ my: 2 }}>
                <TextField
                  label="Title (Myanmar)"
                  value={questionMM}
                  onChange={(e) => setQuestionMM(e.target.value)}
                  error={!!errors.questionMM}
                  helperText={errors.questionMM}
                />
              </FormControl>
            </Box>

            {/* Answers */}
            {answers.map((answer, index) => (
              <Box
                key={index}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  px: 3,
                  columnGap: 5,
                }}
              >
                <FormControl sx={{ my: 2 }}>
                  <TextField
                    label={`Answer EN ${index + 1}`}
                    value={answer.answer_en}
                    onChange={(e) =>
                      handleAnswerChange(index, "answer_en", e.target.value)
                    }
                    error={!!errors.answers && !answer.answer_en.trim()}
                  />
                </FormControl>
                <FormControl sx={{ my: 2 }}>
                  <TextField
                    label={`Answer MM ${index + 1}`}
                    value={answer.answer_mm}
                    onChange={(e) =>
                      handleAnswerChange(index, "answer_mm", e.target.value)
                    }
                    error={!!errors.answers && !answer.answer_mm.trim()}
                  />
                </FormControl>
                <FormControl>
                  <Button
                    variant="contained"
                    sx={{ mt: 2, mb: 4 }}
                    onClick={() => handleRemoveAnswer(index)}
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      border: "none",
                      padding: "14px 0",
                      cursor: "pointer",
                    }}
                  >
                    Delete
                  </Button>
                </FormControl>
              </Box>
            ))}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              <Button
                variant="contained"
                onClick={handleAddAnswer}
                style={{ padding: "8px 16px", marginTop: "10px" }}
              >
                + Add Answer
              </Button>
            </Box>
          </CardContent>

          <CardActions sx={{ justifyContent: "flex-end" }}>
            <LoadingButton
              variant="contained"
              loading={loading}
              onClick={handleCreate}
              sx={{ backgroundColor: "#4b26d1" }}
            >
              Create
            </LoadingButton>
          </CardActions>
        </Card>
      </Box>
    </>
  );
}
